import React, { useCallback, useMemo } from 'react'
import { InboxType } from '../../../server/models/Inbox'

// Context
import { useMyInboxes } from '../../contexts/MyInboxesContext'

// Components
import { Page, Section, SectionActions } from '../../components/Page'
import { Empty } from '../../components/Empty'
import { CreateInboxButton } from './CreateInboxButton'
import { JoinInboxButton } from './JoinInboxButton'
import { InboxCardsContainer } from './OneInboxCard'

export const Inboxes: React.FC = () => {
  const { inboxMemberships, loading, addOrUpdateInbox, removeInbox } = useMyInboxes()
    
  // Extract inboxes from memberships
  const inboxes = useMemo(() => {
    return inboxMemberships
      .filter(membership => membership.inbox)
      .map(membership => membership.inbox as InboxType)
  }, [inboxMemberships])

  const onInboxesJoined = useCallback((inboxesJoined: any[]) => {
    inboxesJoined.forEach(addOrUpdateInbox)
  }, [addOrUpdateInbox])

  const isOwnerOfInbox = useCallback((inbox: InboxType) => {
    const membership = inboxMemberships.find(m => m.inbox?._id === inbox._id)
    return membership?.role === 'owner'
  }, [inboxMemberships])

  const handleInboxDeleted = useCallback((inboxDeleted: InboxType) => {
    removeInbox(inboxDeleted._id)
  }, [removeInbox])

  const handleInboxUpdated = useCallback((newInbox: InboxType) => {
    // Find the membership for this inbox
    const membership = inboxMemberships.find(m => m.inbox?._id === newInbox._id)
      
    if (membership) {
      // Create updated membership with new inbox data
      addOrUpdateInbox({
        ...membership,
        inbox: newInbox
      })
    }
  }, [inboxMemberships, addOrUpdateInbox])

  return (
    <Page>
      <Section title="Your Content Folders">
        <SectionActions>
          <JoinInboxButton onInboxesJoined={onInboxesJoined} />
          <CreateInboxButton onInboxJoined={(newMembership) => onInboxesJoined([newMembership])} />
        </SectionActions>
      </Section>
      {!loading && inboxes.length === 0 && (
        <Empty>
            You have no content folders. Start or Join one now!
        </Empty>
      )}
      <InboxCardsContainer
        inboxes={inboxes}
        onInboxDeleted={handleInboxDeleted}
        onInboxUpdated={handleInboxUpdated}
        isOwnerOfInbox={isOwnerOfInbox}
        loading={loading}
      />
    </Page>
  )
}
